import * as React from 'react';
import renderHtml, { HtmlRenderers } from './render.js';
import { HtmlStyle, HtmlStyles } from './styles.js';

export type HtmlProps = {
  collapse?: boolean;
  renderers?: HtmlRenderers;
  style?: HtmlStyle | (HtmlStyle | undefined)[];
  stylesheet?: HtmlStyles | HtmlStyles[];
  resetStyles?: boolean;
  children: string;
};

const Html: React.FC<HtmlProps> = (props) => {
  return <>{renderHtml(props.children, props)}</>;
};

export default Html;
